// extracted by mini-css-extract-plugin
export default {"bar":"LoadingBar_bar__szBkv","progress-bar-stripes":"LoadingBar_progress-bar-stripes__-ic9R"};